module.exports = __webpack_public_path__ + "static/media/chemical2.d6d0f344.jpg";